<script async setup lang="ts">
import { CULTURE } from '@/composables/helpers'
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'
import t from '@/i18n/translations'

const props = defineProps<{
  minPrice: number
}>()
</script>

<template>
  <div v-if="props.minPrice > 0" class="text-end">
    {{ t(`${CULTURE}.acco.from`) }}
    <span class="font-bold">{{ props.minPrice }} €</span>
    {{ t(`${CULTURE}.acco.perDay`) }}
  </div>
</template>
